module.exports = __webpack_public_path__ + "img/bz.b939235b.png";